import { observer } from "mobx-react-lite";

import { WorkoutItemsRoot } from "src/components/WorkoutItemsRoot";
import { WorkoutItemsDragAndDropManagerProvider } from "src/workouts/WorkoutItemsDragAndDropManagerContext";

export const WorkoutItems = observer(function WorkoutItems() {
  return (
    <WorkoutItemsDragAndDropManagerProvider>
      <WorkoutItemsRoot />
    </WorkoutItemsDragAndDropManagerProvider>
  );
});
